const leetMap = {
  "1": "i",
  "!": "i",
  "0": "o",
  "3": "e",
  "4": "a",
  "5": "s",
  "7": "t",
  "8": "b",
  "9": "g",
};

const koreanBannedWords = [
  "씨발", "시발", "ㅅㅂ", "병신", "개새끼", "개새", "지랄", "좆", "좃", "좃같",
  "씹", "씹새끼", "씹년", "쌍년", "개년", "걸레", "창녀", "보지", "자지",
  "섹스", "섹", "야동", "야설", "야사", "딸딸이", "자위", "음란", "변태",
  "존나", "존내", "존니", "개같", "개같은", "또라이", "미친년", "미친놈",
];

const englishBannedWords = [
  "fuck", "shit", "bitch", "ass", "asshole", "bastard", "dick", "pussy",
  "cunt", "porn", "sex", "xxx", "boob", "tits", "nude", "slut", "whore",
];

const bannedWords = [...koreanBannedWords, ...englishBannedWords];

export function normalizeNickname(nickname) {
  return nickname
    .toLowerCase()
    .split("")
    .map((char) => leetMap[char] || char)
    .join("")
    .replace(/[^\p{L}\p{N}]/gu, "")
    .replace(/\s+/g, "");
}

export function validateNickname(nickname) {
  const trimmed = nickname.trim();

  if (!trimmed) {
    return "닉네임을 입력하세요.";
  }

  if (trimmed.length < 2 || trimmed.length > 20) {
    return "닉네임은 2자 이상 20자 이하여야 합니다.";
  }

  if (!/^[a-zA-Z0-9_]+$/.test(trimmed)) {
    return "닉네임은 영문, 숫자, 밑줄(_)만 사용할 수 있습니다.";
  }

  const normalized = normalizeNickname(trimmed);
  const hasBannedWord = bannedWords.some((word) => normalized.includes(word));

  if (hasBannedWord) {
    return "사용할 수 없는 닉네임입니다.";
  }

  return null;
}
